<div id="containerNotification">
  <div class="textNotif">
    {{ customText }}
  </div>
  <mat-icon class="cancelIcon" (click)="closeMenu()">close</mat-icon>
</div>